import React, { createContext, useState, useContext, ReactNode } from 'react';

// Extend the Theme type to include 'classic'
type Theme = 'light' | 'dark' | 'classic'|'darkblue';

type ThemeContextType = {
  theme: Theme;
  setTheme: (newTheme: Theme) => void; // Function to explicitly set a theme
};

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [theme, setThemeState] = useState<Theme>('dark');

  // Function to set the theme explicitly
  const setTheme = (newTheme: Theme) => {
    setThemeState(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};